import "./gameArtCards.css";

// Shared metadata popout for TikTok games, used by both the card grid
// (VirtualizedTikTokGrid) and the table (VirtualizedTable) box-art hover.
// Positioning is controlled by the `side` prop ("right" | "left" | "below").
export default function TikTokMetadataPopout({ game, side = "right", onMouseEnter }) {
  const metadataName = String(game.displayName || game.name)
    .replace(/\s*\(#[^)]*\)\s*$/, "")
    .trim();
  const hashtag = String(game.hashtag || game.name).trim().replace(/^#+/, "");
  const hashtags = (Array.isArray(game.groupHashtags) && game.groupHashtags.length
    ? game.groupHashtags
    : [hashtag])
    .map((value) => String(value || "").trim().replace(/^#+/, ""))
    .filter(Boolean);

  const latestVideos = game.rankedMetrics && game.rankingMetric === "views";
  const displayVideos = latestVideos
    ? Number(game.videos)
    : game.rankedMetrics
      ? game.videosTotal
      : Number(game.videosTotal ?? game.videos ?? 0);
  const displayViews = game.rankedMetrics
    ? game.viewsTotal
    : Number(game.viewsTotal ?? game.views ?? 0);

  return (
    <div
      className={`tt-card-metadata tt-card-metadata--${side}`}
      role="dialog"
      aria-label={`${game.displayName || game.name} metadata`}
      style={game.imageUrl ? { "--tt-card-metadata-art": `url(${JSON.stringify(game.imageUrl)})` } : undefined}
      onMouseEnter={onMouseEnter}
    >
      <div className="tt-card-metadata-heading">
        <div>
          <strong>{metadataName}</strong>
          <span style={{ overflowWrap: "anywhere" }}>{hashtags.map((tag) => `#${tag}`).join(", ")}</span>
        </div>
      </div>
      {game.description && <p className="tt-card-metadata-description">{game.description}</p>}
      <div className="tt-card-metadata-stats">
        <div><span>Views</span><strong>{displayViews != null && Number.isFinite(Number(displayViews)) ? Number(displayViews).toLocaleString() : "—"}</strong></div>
        <div><span>Videos</span><strong>{displayVideos != null && Number.isFinite(Number(displayVideos)) ? Number(displayVideos).toLocaleString() : "—"}</strong></div>
        {game.delta != null && <div>
          <span>{game.rankingMetric === "videos" ? "Videos gained" : "Views gained"} {game.metricLabel || ""}</span>
          <strong>{Number.isFinite(Number(game.delta)) ? Number(game.delta).toLocaleString() : "—"}
            {game.growth != null && Number.isFinite(Number(game.growth)) ? ` (${(Number(game.growth) * 100).toFixed(1)}%)` : ""}</strong>
        </div>}
      </div>
      <dl className="tt-card-metadata-list">
        {[
          ["Publisher", game.publisher],
          ["Developer", game.developer],
          ["Release", game.release_date],
          ["Genres", Array.isArray(game.genres) ? game.genres.join(", ") : game.genres],
          ["Platforms", Array.isArray(game.platforms) ? game.platforms.join(", ") : game.platforms],
          ["Pricing", game.pricing],
          ["Coverage", game.coverageLabel],
          ["Tags", Array.isArray(game.tags) ? game.tags.join(", ") : game.tags],
        ].filter(([, value]) => value != null && String(value).trim()).map(([label, value]) => (
          <div key={label}><dt>{label}</dt><dd>{value}</dd></div>
        ))}
      </dl>
    </div>
  );
}
